/*

? The reasons a chat report may give (18 Oct 2026), shared by the server's rule
? (lib/chat/reportChat.ts) and the website's report dialog, with the same list as the apps'
? (bbm-android core/utils/chat/ChatReports.kt). Change all three together. Safe to import in the
? browser: nothing here touches the database.

*/

/** The reasons offered when reporting a message or a profile; a report needs at least one. */
export const REPORT_REASONS: Array<string> = [
	"Spam or promotional messages",
	"Harassment or abusive behavior",
	"Fraud or scam",
	"Fake or misleading listing",
	"Inappropriate content",
	"Other",
];
